export const getTrail = (state) => state.trails.trail;
